import React from 'react'

function BarNavAdmins({setVisibilityComments,setVisibilityPeopleAcceptConditions, setVisibilityRamRegister,setVisibilityBd, setVisibilityEstadistica, setVisibilityRegistro}) {
    const functionVisibilityRamRegister = () => {
        setVisibilityBd(false)
        setVisibilityEstadistica(false)
        setVisibilityRegistro(false)
        setVisibilityRamRegister(true)
        setVisibilityPeopleAcceptConditions(false)
        setVisibilityComments(false)
    }

    const functionVisibilityBD = () => {
    setVisibilityBd(true)
    setVisibilityEstadistica(false)
    setVisibilityRegistro(false)
    setVisibilityRamRegister(false)
    setVisibilityComments(false)
    
    setVisibilityPeopleAcceptConditions(false)
}
const functionVisibilityEstadistica = () => {
    setVisibilityBd(false)
    setVisibilityEstadistica(true)
    setVisibilityRegistro(false)
    setVisibilityRamRegister(false)
    setVisibilityComments(false)
    
    setVisibilityPeopleAcceptConditions(false)
}
const functionVisibilityRegistro = () => {
    setVisibilityBd(false)
    setVisibilityEstadistica(false)
    setVisibilityRegistro(true)
    setVisibilityRamRegister(false)
    setVisibilityComments(false)
    
    setVisibilityPeopleAcceptConditions(false)
}


const functionVisibilityAcceptConditions = () => {
    setVisibilityBd(false)
    setVisibilityEstadistica(false)
    setVisibilityRegistro(false)
    setVisibilityRamRegister(false)
    setVisibilityComments(false)
    
    setVisibilityPeopleAcceptConditions(true)

}
const functionVisibilityComments = () => {
    setVisibilityBd(false)
    setVisibilityEstadistica(false)
    setVisibilityRegistro(false)
    setVisibilityRamRegister(false)
    setVisibilityComments(true)
    
    setVisibilityPeopleAcceptConditions(false)

}
    return (
    <div className='container-barnav-admins-platform'>
        <nav className='banvav-platform'>
        <button onClick={() => functionVisibilityRegistro()}>Registrar</button>
        <button onClick={() => functionVisibilityBD()}>BD</button>
        <button onClick={() => functionVisibilityEstadistica()}>Estadisticas</button>
       <button onClick={() => functionVisibilityRamRegister()}>Servidores</button>
        <button onClick={() => functionVisibilityAcceptConditions()}>Consentimientos</button>
        <button onClick={() => functionVisibilityComments()}>Sugerencias</button>
        </nav>
    </div>
  )
}

export default BarNavAdmins